export const generateColorItemsWithGradients = (itemCount: number, colorsForGradient: string[]) => {
  let colors = [];

  for (let i = 0; i < itemCount; i++) {
    const ratio = i / (itemCount - 1);
    const index = Math.floor(ratio * (colorsForGradient.length - 1));
    const nextIndex = Math.min(index + 1, colorsForGradient.length - 1);

    colors.push(
      interpolateColor(
        colorsForGradient[index],
        colorsForGradient[nextIndex],
        ratio * (colorsForGradient.length - 1) - index,
      ),
    );
  }

  return colors;
};

// Function to interpolate between two hex colors
const interpolateColor = (color1: string, color2: string, factor: number) => {
  const c1 = hexToRgb(color1);
  const c2 = hexToRgb(color2);

  const r = Math.round(c1.r + (c2.r - c1.r) * factor);
  const g = Math.round(c1.g + (c2.g - c1.g) * factor);
  const b = Math.round(c1.b + (c2.b - c1.b) * factor);

  return `rgb(${r}, ${g}, ${b})`;
};

// Convert hex to RGB
const hexToRgb = (hex: string) => {
  const hexValue = parseInt(hex.slice(1), 16);
  return {r: (hexValue >> 16) & 255, g: (hexValue >> 8) & 255, b: hexValue & 255};
};
